import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useRoute, useRouter } from 'vue-router';
import { Flash } from '@/core/Flash';
import NewsForm from '@/modules/news/components/NewsForm.vue';
import { News, useNews } from '@/modules/news/News';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const newsItem = ref<News | null>(null);

const load = async () => {
	try {
		const response = await useNews().get(route.params.id as string);
		if (response) {
			newsItem.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'news.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (n) => {
	newsItem.value = n;
	Flash.success($gettext('Nyheten har sparats.'));
};

const cancel = () => {
	router.push({ name: 'news.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewsForm, {
    "page-title": _unref($gettext)('Redigera nyhet'),
    "news-item": newsItem.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "news-item"]))
}
}

})